/**
 * @generated SignedSource<<713fdbbb6cbe746fc0b54418e5b759a2>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type printOSLoginTokenQuery$variables = {
  data: string;
};
export type printOSLoginTokenQuery$data = {
  readonly auth: string;
};
export type printOSLoginTokenQuery = {
  response: printOSLoginTokenQuery$data;
  variables: printOSLoginTokenQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "data"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "data",
        "variableName": "data"
      }
    ],
    "kind": "ScalarField",
    "name": "auth",
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "printOSLoginTokenQuery",
    "selections": (v1/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "printOSLoginTokenQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "c58019c0a9fb43336707bcce7a70197b",
    "id": null,
    "metadata": {},
    "name": "printOSLoginTokenQuery",
    "operationKind": "query",
    "text": "query printOSLoginTokenQuery(\n  $data: String!\n) {\n  auth(data: $data)\n}\n"
  }
};
})();

(node as any).hash = "e16155c0751f2a7101a40e0963dd5263";

export default node;
